module.exports = __webpack_public_path__ + "img/RMR About Us.5632adba.png";